
import { useTranslation } from 'react-i18next';

import { PropsBlockDetails } from './types';

const FolderDetailsAsBlock = ({ FolderDetail, error, FolderStatuses}: PropsBlockDetails): JSX.Element => {
  const { t } = useTranslation();

  const date = new Date(FolderDetail.creation_date);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const formattedDate = `${day}/${month}/${year}`;
  let formattedAmount = ''
  if (FolderDetail.nb_parts) {
    formattedAmount = t('common.subscription-formatted-amount', {amount: FolderDetail.subscriptionGlobalAmount, shareCount: FolderDetail.nb_parts, product: FolderDetail.product_name})

  }

  const PPorPM = FolderDetail.is_physical !== null ?
          <>
            <span
              className={`investor-type ${FolderDetail.is_physical === false ? 'type-pm' : 'type-pp'}`}
              title={t(`investor-type.${FolderDetail.is_physical === false ? 'pm' : 'pp'}-label`)}
            >
              {t(`investor-type.${FolderDetail.is_physical === false ? 'pm' : 'pp'}`)}
            </span>
          </>
          :
          <></>

  return (
    <div className='w-full'>
      <div className="u-txt-size-l u-txt-bold u-mb0">{formattedDate ? formattedDate + ', ' : ''} {PPorPM} {FolderDetail.present} {FolderDetail.nature && <span className={`nature-tag nature-tag-${FolderDetail.nature.toLowerCase()}`} title={t(`nature.${FolderDetail.nature.toLowerCase()}`)}>{FolderDetail.nature}</span>}</div>
      {formattedAmount && <div className="u-txt-size-xs u-mb0 u-max-w-90">{formattedAmount}</div>}
      <div className="u-txt-size-s u-txt-color-ink-1">
        <span>{t('common.folder')} n° {FolderDetail.id}</span>
        {FolderDetail.advisor?.external_id && (<>
          <span>&nbsp;</span>
          <span>({FolderDetail.advisor?.external_id})</span>
        </>)}
      </div>
      {FolderStatuses.length>0 &&<div className="u-txt-size-xs u-mb0 u-max-w-90">({FolderStatuses.join(' - ')})</div>}
      {error &&
        <span className="flex u-mts u-txt-size-s notification notification--error notification--error-small">
                    {t('folder.error.cannot-delete-subscription-folder')}
                </span>
      }
    </div>
  );
}

export default FolderDetailsAsBlock;
